import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function FirstStepsIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3542">
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-sky-50" data-id="element-3543">
        {/* Background: Sun and Clouds */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3544">
          <circle cx="160" cy="40" r="20" fill="#FDE047" data-id="element-3545" />
          <path d="M40 60 Q50 40 70 50 Q90 40 100 60 Q110 70 90 80 L50 80 Q30 70 40 60 Z" fill="white" fillOpacity="0.8" data-id="element-3546" />
        </svg>

        {/* Background: Hill */}
        <svg className="absolute bottom-0 left-0 w-full h-1/2 z-0" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3547">
          <path d="M0 50 Q100 -20 200 50 L200 100 L0 100 Z" fill="#86EFAC" data-id="element-3548" />
          <path d="M0 60 Q100 0 200 60 L200 100 L0 100 Z" fill="#4ADE80" data-id="element-3549" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3550">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3551">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} variant={variant} accessory="seedling" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3552" />
          </div>
        </div>

        {/* Foreground: Extra grass/dirt */}
        <svg className="absolute bottom-0 left-0 w-full h-1/4 z-20" viewBox="0 0 200 50" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3553">
          <path d="M80 40 L85 25 L90 40 Z" fill="#22C55E" data-id="element-3554" />
          <path d="M120 45 L123 30 L126 45 Z" fill="#22C55E" data-id="element-3555" />
          <ellipse cx="100" cy="45" rx="30" ry="5" fill="#A16207" fillOpacity="0.3" data-id="element-3556" />
        </svg>
      </div>
    </DjayIllustrationBase>;
}